module.exports = __webpack_public_path__ + "img/hungary.d33c9f96.svg";